import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import { concat, fn } from "@ember/helper";
import { on } from "@ember/modifier";
import { action } from "@ember/object";
import getURL from "discourse/lib/get-url";
import { eq } from "discourse/truth-helpers";
import dConcatClass from "discourse/ui-kit/helpers/d-concat-class";
import { i18nForOwner } from "discourse/plugins/discourse-rewind/discourse/lib/rewind-i18n";

/**
 * Component displaying most viewed categories in rewind report
 * @component
 * @param {Object} report - Report data containing category view counts
 */
export default class MostViewedCategories extends Component {
  @tracked openedCategoryId = null;

  get titleText() {
    return i18nForOwner(
      "discourse_rewind.reports.most_viewed_categories.title",
      this.args.isOwnRewind,
      {
        count: this.args.report.data.length,
        username: this.args.user?.username,
      }
    );
  }

  /**
   * Handles click on folder-wrapper, we want to open
   * the folder on click then navigate to it on second click.
   * @action
   */
  @action
  handleFolderClick(categoryId, event) {
    if (this.openedCategoryId === categoryId) {
      return;
    }

    event.preventDefault();
    this.openedCategoryId = categoryId;
  }

  <template>
    <div class="rewind-report-page --most-viewed-categories">
      <h2 class="rewind-report-title">
        {{this.titleText}}
      </h2>
      <div class="rewind-report-container">
        {{#each @report.data as |data|}}
          <a
            class={{dConcatClass
              "folder-wrapper"
              (if (eq this.openedCategoryId data.category_id) "--opened" "")
            }}
            href={{getURL (concat "/c/-/" data.category_id)}}
            {{on "click" (fn this.handleFolderClick data.category_id)}}
          >
            <span class="folder-tab"></span>
            <div class="rewind-card">
              <p class="most-viewed-categories__category">#{{data.name}}</p>
            </div>
            <span class="folder-bg"></span>
          </a>
        {{/each}}
      </div>
    </div>
  </template>
}
